import dayjs from "dayjs";
import packageJson from '../package.json';
export const {v4: uuidv4} = require('uuid');
export const currentDate = dayjs();
export const appVersion = packageJson.version

// let URL_WEB_PROD =  se-insurer.isurvey.mobi

// ********************************************************************************************
//  Project name
export const projectName = 'SE-Survey'
export const projectSubName = ''
// ********************************************************************************************
// let UAT = "https://dev-api-se.isurvey.mobi/api/v1"
// let UAT = "https://web-api-se-dot-dmd-dev-365305.et.r.appspot.com/api/v1"
// let UAT = "https://greenfield-api-dot-dmd-dev-365305.et.r.appspot.com/api/v1"
let PROD = "https://api-gf.isurvey.mobi/api/v1"
export const API_URL = PROD


// let CHAT_URL = 'https://chat-f52nc6zhua-de.a.run.app' //Default
let CHAT_URL = 'https://isurvey-se-gcp.as.r.appspot.com' // GF(SE) app engine
export const API_CHAT_URL = CHAT_URL

export const timer = 60000 // 1 นาที = 60,000 มิลลิวินาที

export const firebaseConfig = {
    // apiKey: "AIzaSyAbF8v-6bcvY0He4k7nhyPJg9O3IPhamiE",
    // authDomain: "isurveymsg.firebaseapp.com",
    // databaseURL: "https://isurveymsg.firebaseio.com",
    // projectId: "isurveymsg",
    // storageBucket: "isurveymsg.appspot.com",
    // messagingSenderId: "743474547904",
    // appId: "1:743474547904:web:5b5a5fa6bc9cf14dafb125",
    // vapidKey: 'BD6gcOviXutAwxinAYDZWqlvVg4hXQXTCKlWnbiAMl42hgZ4nr7cDD5JwcXPFZ5c5QNX3zUhZwDROROe4h0g1UA'

    apiKey: "AIzaSyAFvm1s7-J_eLJNFnyBhk4ujsMFQgUXyHk",
    authDomain: "isurveymsg.firebaseapp.com",
    databaseURL: "https://isurveymsg.firebaseio.com",
    projectId: "isurveymsg",
    storageBucket: "isurveymsg.appspot.com",
    messagingSenderId: "743474547904",
    appId: "1:743474547904:web:1e24cf53aae4b0fcafb125",
    vapidKey: 'BD6gcOviXutAwxinAYDZWqlvVg4hXQXTCKlWnbiAMl42hgZ4nr7cDD5JwcXPFZ5c5QNX3zUhZwDROROe4h0g1UA'
};

